import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../store'
import { collaborationsApi } from '../redux/collaborationsApi'
import { updateBidStatus, updateCollaboration } from '../lib/api'

// Unused hooks removed: useAcceptBid, useRejectBid, useRestoreBid
// If they are needed later, they should use the thunks in campaignsSlice (acceptCampaign etc.)

export const useSubmitLivePostLink = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [isPending, setIsPending] = useState(false)

  const mutate = async (
    variables: { id: string; livePostLink: string },
    options?: { onSuccess?: () => void; onError?: (error: any) => void },
  ) => {
    setIsPending(true)
    try {
      await updateCollaboration(variables.id, { livePostLink: variables.livePostLink })
      dispatch(collaborationsApi.util.invalidateTags(['Collaboration']))
      options?.onSuccess?.()
    } catch (error) {
      console.error('Submit live post link failed:', error)
      options?.onError?.(error)
    } finally {
      setIsPending(false)
    }
  }

  return { mutate, isPending }
}

/**
 * Mark a collaboration notification as seen on the server.
 */
export const useMarkNotificationShown = () => {
  const dispatch = useDispatch<AppDispatch>()
  // This operation is usually fast, maybe we don't need isPending

  const mutate = async (
    id: string,
    options?: { onSuccess?: (data: any, variables: any) => void; onError?: (error: any) => void },
  ) => {
    try {
      await updateCollaboration(id, { notificationShown: true })
      // We could implement optimistic update here by modifying redux state directly if we had an action for it.
      // For now, simple refetch or just ignore (since notification is shown on UI anyway usually)
      // Let's refetch to be consistent with invalidation
      dispatch(collaborationsApi.util.invalidateTags(['Collaboration']))
      options?.onSuccess?.(null, id)
    } catch (error) {
      console.error('Mark notification shown failed:', error)
      options?.onError?.(error)
    }
  }

  return { mutate }
}

/**
 * Mark a collaboration due-date notification as shown on the server.
 */
export const useMarkDueDateNotificationShown = () => {
  const dispatch = useDispatch<AppDispatch>()

  const mutate = async (
    id: string,
    options?: { onSuccess?: (data: any, variables: any) => void; onError?: (error: any) => void },
  ) => {
    try {
      await updateCollaboration(id, { dueDateNotificationShown: true })
      dispatch(collaborationsApi.util.invalidateTags(['Collaboration']))
      options?.onSuccess?.(null, id)
    } catch (error) {
      console.error('Mark due-date notification shown failed:', error)
      options?.onError?.(error)
    }
  }

  return { mutate }
}
